// class XHRService {
//   constructor(config = {}) {
//     this.baseURL = config.baseURL || "";
//     this.defaultHeaders = config.headers || {};
//     this.timeout = config.timeout || 300000;
//   }

//   request(config) {
//     const {
//       method = "GET",
//       url,
//       params = {},
//       data = null,
//       headers = {},
//       timeout = this.timeout,
//       onProgress = null,
//       onChunk = null,
//       signal = null, // NEW: AbortSignal support
//     } = config;

//     return new Promise((resolve, reject) => {
//       const xhr = new XMLHttpRequest();

//       const fullURL = this.buildURL(url, params);
//       xhr.open(method, fullURL, true);

//       const allHeaders = { ...this.defaultHeaders, ...headers };
//       Object.keys(allHeaders).forEach((key) => {
//         xhr.setRequestHeader(key, allHeaders[key]);
//       });

//       xhr.timeout = timeout;

//       // NEW: Handle abort signal
//       if (signal) {
//         if (signal.aborted) {
//           xhr.abort();
//           reject(new DOMException("Aborted", "AbortError"));
//           return;
//         }

//         signal.addEventListener("abort", () => {
//           xhr.abort();
//           reject(new DOMException("Aborted", "AbortError"));
//         });
//       }

//       let lastIndex = 0;
//       let buffer = "";

//       xhr.onprogress = (event) => {
//         const progress = {
//           loaded: event.loaded,
//           total: event.total,
//           percentage: event.lengthComputable
//             ? (event.loaded / event.total) * 100
//             : null,
//         };

//         if (onProgress) {
//           onProgress(progress);
//         }

//         if (onChunk && xhr.responseText) {
//           try {
//             const responseText = xhr.responseText;

//             if (responseText.startsWith("[")) {
//               const newText = responseText.substring(lastIndex);
//               buffer += newText;

//               const chunks = this.extractCompleteObjects(buffer);

//               if (chunks.length > 0) {
//                 onChunk(chunks);
//                 buffer = this.cleanBuffer(buffer, chunks);
//               }

//               lastIndex = responseText.length;
//             }
//           } catch (e) {
//             // Continue waiting for more data
//           }
//         }
//       };

//       xhr.onload = () => {
//         if (xhr.status >= 200 && xhr.status < 300) {
//           try {
//             const response = JSON.parse(xhr.responseText);
//             resolve(response);
//           } catch (error) {
//             reject(new Error(`Parse error: ${error.message}`));
//           }
//         } else {
//           reject(new Error(`HTTP ${xhr.status}: ${xhr.statusText}`));
//         }
//       };

//       xhr.onerror = () => reject(new Error("Network error"));
//       xhr.ontimeout = () => reject(new Error(`Timeout after ${timeout}ms`));
//       xhr.onabort = () => reject(new DOMException("Aborted", "AbortError"));

//       if (data) {
//         xhr.send(JSON.stringify(data));
//       } else {
//         xhr.send();
//       }
//     });
//   }

//   extractCompleteObjects(text) {
//     const objects = [];
//     let depth = 0;
//     let objStart = -1;

//     for (let i = 0; i < text.length; i++) {
//       const char = text[i];

//       if (char === "{") {
//         if (depth === 0) objStart = i;
//         depth++;
//       } else if (char === "}") {
//         depth--;
//         if (depth === 0 && objStart !== -1) {
//           try {
//             const objText = text.substring(objStart, i + 1);
//             const obj = JSON.parse(objText);
//             objects.push(obj);
//             objStart = -1;
//           } catch (e) {
//             // Not a complete object yet
//           }
//         }
//       }
//     }

//     return objects;
//   }

//   cleanBuffer(buffer, processedObjects) {
//     let cleaned = buffer;
//     processedObjects.forEach((obj) => {
//       const objStr = JSON.stringify(obj);
//       cleaned = cleaned.replace(objStr, "");
//     });
//     return cleaned;
//   }

//   buildURL(url, params) {
//     const fullURL = this.baseURL + url;

//     if (Object.keys(params).length === 0) {
//       return fullURL;
//     }

//     const searchParams = new URLSearchParams();
//     Object.keys(params).forEach((key) => {
//       const value = params[key];
//       searchParams.append(
//         key,
//         typeof value === "object" ? JSON.stringify(value) : value,
//       );
//     });

//     return `${fullURL}?${searchParams.toString()}`;
//   }

//   get(url, config = {}) {
//     return this.request({ ...config, method: "GET", url });
//   }

//   post(url, data, config = {}) {
//     return this.request({ ...config, method: "POST", url, data });
//   }
// }

// const xhr = new XHRService({
//   baseURL: "https://api.innque.com/v1/collections",
//   headers: {
//     "Content-Type": "application/json",
//     Accept: "application/json",
//     "X-Application-Id": "forbes-negrec",
//     "X-Master-key": "f4c7cbbb-c4f3-48bf-90e2-a7521815d25d",
//   },
//   timeout: 300000,
// });

// export { XHRService };
// export default xhr;

class XHRService {
  constructor(config = {}) {
    this.baseURL = config.baseURL || "";
    this.defaultHeaders = config.headers || {};
    this.timeout = config.timeout || 300000;
  }

  request(config) {
    const {
      method = "GET",
      url,
      params = {},
      data = null,
      headers = {},
      timeout = this.timeout,
      onProgress = null,
      onChunk = null,
      signal = null,
      baseURL = this.baseURL, // allow per-call override (e.g. aggregate())
    } = config;

    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      const fullURL = this.buildURL(url, params, baseURL);
      xhr.open(method, fullURL, true);

      const allHeaders = { ...this.defaultHeaders, ...headers };
      Object.keys(allHeaders).forEach((key) => {
        xhr.setRequestHeader(key, allHeaders[key]);
      });

      xhr.timeout = timeout;

      if (signal) {
        if (signal.aborted) {
          xhr.abort();
          reject(new DOMException("Aborted", "AbortError"));
          return;
        }
        signal.addEventListener("abort", () => {
          xhr.abort();
          reject(new DOMException("Aborted", "AbortError"));
        });
      }

      let lastIndex = 0;
      let buffer = "";

      xhr.onprogress = (event) => {
        const progress = {
          loaded: event.loaded,
          total: event.total,
          percentage: event.lengthComputable
            ? (event.loaded / event.total) * 100
            : null,
        };

        if (onProgress) onProgress(progress);

        if (onChunk && xhr.responseText) {
          try {
            const responseText = xhr.responseText;

            if (responseText.startsWith("[")) {
              const newText = responseText.substring(lastIndex);
              buffer += newText;

              const { objects, consumedUpTo } =
                this.extractCompleteObjects(buffer);

              if (objects.length > 0) {
                onChunk(objects);
                buffer = buffer.slice(consumedUpTo);
              }

              lastIndex = responseText.length;
            }
          } catch (e) {
            // Continue waiting for more data
          }
        }
      };

      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            const response = JSON.parse(xhr.responseText);
            resolve(response);
          } catch (error) {
            reject(new Error(`Parse error: ${error.message}`));
          }
        } else {
          reject(new Error(`HTTP ${xhr.status}: ${xhr.statusText}`));
        }
      };

      xhr.onerror = () => reject(new Error("Network error"));
      xhr.ontimeout = () => reject(new Error(`Timeout after ${timeout}ms`));
      xhr.onabort = () => reject(new DOMException("Aborted", "AbortError"));

      if (data) {
        xhr.send(JSON.stringify(data));
      } else {
        xhr.send();
      }
    });
  }

  extractCompleteObjects(text) {
    const objects = [];
    let depth = 0;
    let objStart = -1;
    let consumedUpTo = 0;

    for (let i = 0; i < text.length; i++) {
      const char = text[i];

      if (char === "{") {
        if (depth === 0) objStart = i;
        depth++;
      } else if (char === "}") {
        depth--;
        if (depth === 0 && objStart !== -1) {
          try {
            const objText = text.substring(objStart, i + 1);
            const obj = JSON.parse(objText);
            objects.push(obj);
            consumedUpTo = i + 1;
            objStart = -1;
          } catch (e) {
            // Not a complete object yet
          }
        }
      }
    }

    return { objects, consumedUpTo };
  }

  buildURL(url, params, base = this.baseURL) {
    const fullURL = base + url;

    if (Object.keys(params).length === 0) {
      return fullURL;
    }

    const searchParams = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      const value = params[key];
      searchParams.append(
        key,
        typeof value === "object" ? JSON.stringify(value) : value,
      );
    });

    return `${fullURL}?${searchParams.toString()}`;
  }

  get(url, config = {}) {
    return this.request({ ...config, method: "GET", url });
  }

  post(url, data, config = {}) {
    return this.request({ ...config, method: "POST", url, data });
  }

  aggregate(collection, pipeline, config = {}) {
    // /aggregate lives at the API root, as a sibling of /collections
    const aggregateBaseURL = this.baseURL.replace(/\/collections\/?$/, "");
    return this.get(`/aggregate/${collection}`, {
      ...config,
      baseURL: aggregateBaseURL,
      params: { ...(config.params || {}), pipeline },
    });
  }
}

const xhr = new XHRService({
  baseURL: "https://api.innque.com/v1/collections",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "X-Application-Id": "forbes-negrec",
    "X-Master-key": "f4c7cbbb-c4f3-48bf-90e2-a7521815d25d",
  },
  timeout: 300000,
});

export { XHRService };
export default xhr;
